import { FC } from 'react'
import AuthLayout from '~/app/components/layouts/AuthLayout'
import { ForgotPasswordContent } from '~/app/components/modules/ForgotPassword'

const ForgotPasswordPage: FC = () => {
  return (
    <AuthLayout>
      <ForgotPasswordContent />
    </AuthLayout>
  )
}

export default ForgotPasswordPage
